<template>
  <div>
    Giriş Adetleri
    <ul>
      <li>
        - Mekanik Girişi
      </li>
      <li>
        ----- Marka Bazlı Adetler
      </li>
      <li>
        ----- Geçmiş dönem ile değişim oranı %
      </li>
      <li>
        - Kaporta Girişi
      </li>
      <li>
        ----- Marka Bazlı Adetler
      </li>
      <li>
        ----- Geçmiş dönem ile değişim oranı %
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'Services',
}
</script>
